import React from "react";

// Grey placeholders in the shape of the content while it loads.
export default function ListSkeleton({ rows = 5, label = "Caricamento…", className = "" }) {
  return (
    <div role="status" aria-live="polite" className={`space-y-3 p-4 ${className}`}>
      <span className="sr-only">{label}</span>
      <div className="skeleton h-4 w-1/3" aria-hidden="true" />
      {Array.from({ length: rows }, (_, i) => (
        <div key={i} className="flex items-center gap-3" aria-hidden="true">
          <div className="skeleton h-10 w-10 shrink-0" />
          <div className="flex-1 space-y-2">
            <div className="skeleton h-3.5" style={{ width: `${70 - (i % 3) * 12}%` }} />
            <div className="skeleton h-3 w-1/4" />
          </div>
        </div>
      ))}
    </div>
  );
}
